import React from 'react';
import PropTypes from 'prop-types';
import './ActivateUsedCategoryModal.scss';
import ModalWithConfirmationButtons from 'react/components/common/Modal/ModalWithConfirmationButtons/ModalWithConfirmationButtons';

// PHOB-1862 req 2.3. Copy is product's, verbatim from the ticket — do not reword.
const ActivateUsedCategoryModal = ({
  isOpen,
  audienceName,
  categoryId,
  dataContractText,
  onConfirm,
  onCancel,
  isProcessing,
}) => (
  <div className="activate-used-category-modal-component">
    <ModalWithConfirmationButtons
      width="480px"
      modalTitle="Activate audience to a used category"
      isOpen={isOpen}
      onSubmit={onConfirm}
      onCancel={onCancel}
      submitLabel="Activate"
      cancelLabel="Cancel"
      isSubmitDisabled={isProcessing}
      isCancelDisabled={isProcessing}
      showSpinner={isProcessing}
      isLightTheme={true}
      isCancelTransparent={true}
      titleMargin={'0 0 16px 0'}
    >
      <div className="activate-used-category-body">
        <div className="activate-used-category-question">
          Are you sure you want to activate the audience <span className="bold">{audienceName}</span> to the category{' '}
          <span className="bold">{categoryId}</span> under <span className="bold">{dataContractText}</span>?
        </div>
        <div className="activate-used-category-overwrite">It will overwrite the data in the category</div>
      </div>
    </ModalWithConfirmationButtons>
  </div>
);

ActivateUsedCategoryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  audienceName: PropTypes.string,
  categoryId: PropTypes.string,
  dataContractText: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool,
};

ActivateUsedCategoryModal.defaultProps = { isProcessing: false };

export default ActivateUsedCategoryModal;
